import cn from 'classnames';
import { FC, useCallback, useState } from 'react';
import { ReactSVG } from 'react-svg';
import _styles from './styles.module.scss';

type Props = {
  className?: string;
  onClick?: () => void;
  pointer?: boolean;
  rotate?: '90' | '180' | '270' | '360';
  color?:
    | 'primaryDark'
    | 'primaryText'
    | 'secondary'
    | 'primary'
    | 'third'
    | 'valid'
    | 'error'
    | 'white'
    | 'red'
    | 'brand'
    | string;
  size?: 'xs' | 'sm' | 'md' | 'mdm' | 'lg' | 'xl' | 'xxl' | 'xxxl';
  src: string;
  top?: '1' | '2' | '3' | '4';
  id?: string;
  styles?: Record<string, string>;
  display?: 'block' | 'inline-block';
  name?: string;
  nameClassName?: string;
};

export const SvgIcon: FC<Props> = ({
  className,
  nameClassName,
  pointer,
  onClick,
  rotate,
  color,
  size,
  src,
  top,
  id,
  styles = {},
  display,
  name,
}) => {
  const [svgExists, setSvgExists] = useState<boolean>(true);

  // Wrap onError to defer setState, preventing React #185
  const handleError = useCallback((): void => {
    // defer to next tick so React doesn't complain about setState during render
    setTimeout(() => setSvgExists(false), 0);
  }, []);

  const wrapperStyle = Object.keys(styles).length ? styles : undefined;

  // fallback if SVG fails
  if (!svgExists) {
    return <span className={cn(_styles.provider_name, nameClassName)}>{name || ''}</span>;
  }

  const wrapperClassName = cn(
    _styles.svgIcon,
    {
      [_styles[`svgIcon_rotate_${rotate}`]]: rotate,
      [_styles[`svgIcon_color_${color}`]]: color,
      [_styles[`svgIcon_size_${size}`]]: size,
      [_styles[`svgIcon_top_${top}`]]: top,
      [_styles['svgIcon_pointer']]: pointer,
      [_styles[`svgIcon_display_${display}`]]: display,
    },
    className
  );

  return (
    <span style={wrapperStyle} onClick={onClick}>
      <ReactSVG className={wrapperClassName} src={src} id={id} onError={handleError} />
    </span>
  );
};
